<template>
    <view-visualization>
        <template #reservoir-info="{ reservoirInfo: data }">
            <b-form-group label="Cota montante">
                <b-input-group append="m">
                    <swx-number-input
                        ref="swxNumberInput"
                        :value="data.quota_flux"
                        name="quota_flux"
                        disabled
                    />
                </b-input-group>
            </b-form-group>
            <b-form-group label="Cota jusante">
                <b-input-group append="m">
                    <swx-number-input
                        ref="swxNumberInput"
                        :value="data.quota_downstream"
                        name="quota_downstream"
                        disabled
                    />
                </b-input-group>
            </b-form-group>
            <div class="mb-1">Comportas</div>
            <b-table
                small
                bordered
                striped
                :fields="[
                    {
                        key: 'index',
                        label: 'Comporta',
                        thClass: 'text-center font-weight-normal',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'open',
                        label: 'Aberta',
                        thClass: 'text-center font-weight-normal',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'gap',
                        label: 'Abertura (m)',
                        thClass: 'text-center font-weight-normal',
                        tdClass: 'text-right'
                    }
                ]"
                :items="data.water_gates"
                table-class="mb-0"
                show-empty
                empty-text="Nenhum dado de comportas encontrado."
            >
                <template v-slot:empty="scope">
                    <span class="text-muted">{{ scope.emptyText }}</span>
                </template>
                <template #cell(index)="scope">
                    C-{{ `${scope.index + 1}`.padStart(2, "0") }}
                </template>
                <template #cell(open)="scope">
                    <b-form-checkbox :checked="scope.item > 0" disabled />
                </template>
                <template #cell(gap)="scope">
                    {{ format(scope.item) }}
                </template>
            </b-table>
            <div class="mb-1 mt-3">Termômetros de concreto</div>
            <chosen-concrete-temperature-readings :epoch="data.epoch" />
        </template>
    </view-visualization>
</template>
<script>
import ViewVisualization from "@/modules/common/views/ViewVisualization";
import SwxNumberInput from "@/components/SwxNumberInput";
import ChosenConcreteTemperatureReadings from "./components/ChosenConcreteTemperatureReadings";
export default {
    name: "Visualization",
    components: {
        ViewVisualization,
        SwxNumberInput,
        ChosenConcreteTemperatureReadings
    },
    methods: {
        format(value) {
            return this.$refs.swxNumberInput.format(value);
        }
    }
};
</script>
